/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * To check if a request is pending or complete regardless of success or failure
 */
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["PENDING"] = "PENDING";
    RequestStatus["COMPLETE"] = "COMPLETE";
})(RequestStatus || (RequestStatus = {}));
